"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpApi = void 0;
var browser_1 = require("@cian/config/browser");
var convertRequestConfig_1 = require("../../../shared/internal/HttpApi/convertRequestConfig");
var HTTPRequestConfig_1 = require("../../../shared/internal/HTTPRequestConfig");
var Context_1 = require("../Context/Context");
var Headers_1 = require("../../../shared/internal/HTTPRequestConfig/Headers");
var Request_1 = require("../HTTP/Request");
var FetchRequest_1 = require("../HTTP/FetchRequest");
var URL_1 = require("../URI/URL");
var utils_1 = require("../../../shared/internal/HTTP/utils");
var HttpApi = /** @class */ (function () {
    function HttpApi(params) {
        this.hooksFactories = [];
        this.circuitBreakerHash = params.circuitBreakerHash;
        this.assertStatusCode = params.assertStatusCode;
    }
    HttpApi.prototype.addHook = function (factory) {
        this.hooksFactories.push(factory);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    HttpApi.prototype.fetch = function (model, fetchConfig) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var uri, headers, requestConfig, config, context, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        uri = (0, URL_1.createURL)({
                            model: model,
                            subdomain: fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.subdomain,
                            transformBodyToLegacyString: fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.transformBodyToLegacyString,
                        });
                        headers = new Headers_1.Headers(((_a = fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.requestConfig) === null || _a === void 0 ? void 0 : _a.headers) || {});
                        requestConfig = new HTTPRequestConfig_1.HTTPRequestConfig({
                            model: model,
                            transformBodyToLegacyString: fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.transformBodyToLegacyString,
                            bodyAsEncodeString: fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.bodyAsEncodeString,
                            headers: headers,
                            url: uri,
                            withCredentials: (_b = fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.requestConfig) === null || _b === void 0 ? void 0 : _b.withCredentials,
                        });
                        config = (0, browser_1.getConfig)().attach({
                            context: {
                                api_request_path: model.pathApi,
                                api_request_base_url_key: model.microserviceName,
                            },
                        });
                        context = new Context_1.Context({
                            userConfig: fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.ecnhancersConfig,
                            assertStatusCode: this.assertStatusCode,
                            model: model,
                            config: config,
                            requestedServerName: model.microserviceName,
                            cancellationToken: fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.cancellationToken,
                            requestConfig: requestConfig,
                            pathSimplified: fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig.pathSimplified,
                        });
                        return [4 /*yield*/, this.sendRequest(requestConfig, context)];
                    case 1:
                        response = _c.sent();
                        return [2 /*return*/, {
                                headers: response.responseHeaders.toArray(),
                                response: response.responseBody,
                                statusCode: response.responseStatusCode,
                            }];
                }
            });
        });
    };
    HttpApi.prototype.httpRequest = function (request, httpApiConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, internalRequestConfig, requestHash, config, context;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = new Headers_1.Headers(request.headers || {});
                        internalRequestConfig = (0, convertRequestConfig_1.convertRequestConfig)(request, headers);
                        requestHash = this.circuitBreakerHash && this.circuitBreakerHash(request);
                        config = (0, browser_1.getConfig)().attach({
                            context: {
                                api_request_path: request.uri.path,
                                api_request_base_url_key: request.uri.host,
                            },
                        });
                        context = new Context_1.Context({
                            userConfig: httpApiConfig,
                            requestHash: requestHash,
                            config: config,
                            assertStatusCode: this.assertStatusCode,
                            requestedServerName: internalRequestConfig.url.host,
                            cancellationToken: httpApiConfig === null || httpApiConfig === void 0 ? void 0 : httpApiConfig.cancellationToken,
                            requestConfig: internalRequestConfig,
                            pathSimplified: httpApiConfig === null || httpApiConfig === void 0 ? void 0 : httpApiConfig.pathSimplified,
                        });
                        return [4 /*yield*/, this.sendRequest(internalRequestConfig, context, 'string')];
                    case 1: return [2 /*return*/, (_a.sent()).complete()];
                }
            });
        });
    };
    HttpApi.prototype.sendRequest = function (requestConfig, context, responseType) {
        return __awaiter(this, void 0, void 0, function () {
            var hooks, request_1, response_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hooks = this.hooksFactories.map(function (factory) { return factory({ context: context, requestConfig: requestConfig }); });
                        /** @deprecated В следующем мажоре Content-Type должен устанавливаться всегда, без возможности управления */
                        if (context.legacyRequestContentTypeEnabled) {
                            (0, utils_1.setRequestContentType)(requestConfig.headers, requestConfig.requestType);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        request_1 = context.requestType === 'fetch'
                            ? new FetchRequest_1.FetchRequest({
                                requestConfig: requestConfig,
                                timeout: context.timeout,
                                requestServerName: context.requestedServerName,
                                responseType: responseType,
                            })
                            : new Request_1.Request({
                                requestConfig: requestConfig,
                                timeout: context.timeout,
                                requestServerName: context.requestedServerName,
                                responseType: responseType,
                            });
                        hooks.forEach(function (hook) { return hook.onRequest(request_1); });
                        return [4 /*yield*/, request_1.send()];
                    case 2:
                        response_1 = _a.sent();
                        return [4 /*yield*/, response_1.compileBody()];
                    case 3:
                        _a.sent();
                        hooks.forEach(function (hook) { return hook.onResponse(response_1); });
                        return [2 /*return*/, response_1];
                    case 4:
                        error_1 = _a.sent();
                        hooks.forEach(function (hook) { return hook.onError(error_1); });
                        throw error_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return HttpApi;
}());
exports.HttpApi = HttpApi;
//# sourceMappingURL=HttpApi.js.map